module.exports = __webpack_public_path__ + "media/images/icons/tutoring-package-1-6319f52532e84abe3e112a1c94e1f54d.svg";